module.exports = __webpack_public_path__ + "img/x4_1ba4e6230.png";